import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Switch,
  Typography
} from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import {useState} from 'react';
import {CmsFeatureTemplateMassiveAction} from '../state/cms-feature-template-page-state';

export type Props = {
  massiveAction: CmsFeatureTemplateMassiveAction
  isSaveDisabled: boolean
  areAllExpanded: boolean
  toggleExpandAll: () => void
  onConfirmSave: () => Promise<void>
  setMassiveAction: (massiveAction: CmsFeatureTemplateMassiveAction) => void
  translate: (key: string) => string
  translateLocal: (key: string) => string
}

export const CmsFeatureTemplateActionsBar = ({massiveAction, setMassiveAction, onConfirmSave, isSaveDisabled, areAllExpanded, toggleExpandAll, translate, translateLocal}: Props) => {
  const [openConfirm, setOpenConfirm] = useState(false);

  const isEditMode = massiveAction === 'update_feature_template';

  const handleConfirm = async () => {
    await onConfirmSave();
    setOpenConfirm(false);
  };

  return (
    <Box sx={{ pb: 2, mb: 1, display: 'flex', alignItems: 'center', gap: 2, borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
      <FormControlLabel
        sx={{ m: 0 }}
        control={
          <Switch
            checked={isEditMode}
            onChange={(_, checked) => setMassiveAction(checked ? 'update_feature_template' : 'no_action')}
          />
        }
        label={translateLocal('action.update_feature_template.title')}
      />

      {isEditMode && (
        <>
          <Button variant="contained" color="primary" onClick={() => setOpenConfirm(true)} disabled={isSaveDisabled}>
            {translate('common.save.title')}
          </Button>
          <Button variant="outlined" onClick={() => setMassiveAction('no_action')}>
            {translate('common.cancel.title')}
          </Button>
        </>
      )}

      <Box sx={{ ml: 'auto' }}>
        <Button variant="outlined" size="small" onClick={toggleExpandAll}>
          {areAllExpanded ? translateLocal('action.collapse_all') : translateLocal('action.expand_all')}
        </Button>
      </Box>

      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>{translateLocal('actions.confirm.title')}</DialogTitle>
        <DialogContent>
          <Typography>{translateLocal('actions.confirm.description')}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>{translate('common.cancel.title')}</Button>
          <Button onClick={handleConfirm} variant="contained" color="primary">{translate('common.save.title')}</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
